import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import Validator from '../Form/Validator';
import FormInput from '../Form/FormInput';
import FormSpamProtection from '../Form/FormSpamProtection';
import RequestProgress from '../Progress/RequestProgress';
import Button from '../Button/Button';

export default function ChangeUserForm(props) {
  const intl = useIntl();
  const [email, setEmail] = useState('');
  const [emailIsValid, setEmailIsValid] = useState(false);
  const [isRightAntiSpamAnswer, setIsRightAntiSpamAnswer] = useState(false);
  const [submitButtonIsClicked, setSubmitButtonIsClicked] = useState(false);
  const [viewState, setViewState] = useState('form');
  const [resultMessageType, setResultMessageType] = useState('');
  const [resultMessageText, setResultMessageText] = useState('');

  const emailChangeHandler = (newEmail) => {
    setEmail(newEmail);
    setEmailIsValid(Validator.isValidEmailAddress(newEmail));
  };
  const isRightAntiSpamAnswerChangeHandler = (newAntiSpamAnswer) => {
    setIsRightAntiSpamAnswer(newAntiSpamAnswer);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitButtonIsClicked(true);
    if (emailIsValid && isRightAntiSpamAnswer) {
      setViewState('loading');
      props.services.apiService.post('/user/pwd-reset-request', {
        email,
        locale: props.locale,
      }).then((res) => {
        setViewState('result');
        if (res.data) {
          setResultMessageText(intl.formatMessage({ id: 'passwordOptInSuccessMsg' }));
          setResultMessageType('success');
        } else {
          setResultMessageText(intl.formatMessage({ id: 'errorHasOccurred' }));
          setResultMessageType('error');
        }
      });
    }
  };
  return (
    <Fragment>
      <RequestProgress viewState={viewState} processingLabel={intl.formatMessage({ id: 'requestIsBeingProcessed' })} messageType={resultMessageType} messageText={resultMessageText} />
      {(viewState === 'form' || resultMessageType === 'error') && (
        <form className="form form-centered" onSubmit={handleSubmit}>
          <div className="grid-form">
            <FormInput
              id="email"
              value={email}
              callback={emailChangeHandler}
              isValid={emailIsValid}
              errorMessageId="invalidNewEmailMessage"
              noErrorMessageIfEmpty={!submitButtonIsClicked}
            />
            <FormSpamProtection
              callback={isRightAntiSpamAnswerChangeHandler}
              noErrorMessageIfEmpty={!submitButtonIsClicked}
            />
          </div>
          <Button classNames="button button--full-width" type="submit"><FormattedMessage id="next" /></Button>
        </form>
      )}
    </Fragment>
  );
}

ChangeUserForm.propTypes = {
  services: PropTypes.objectOf(PropTypes.object).isRequired,
  locale: PropTypes.string.isRequired,
};
